import type { AssetResultMatch } from '../types';

/**
 * Filters out matches that are not explicitly being queried for
 * and hence only have a single field (__typename)
 */
export const getValidAssetResultMatches = (
  matches: unknown[]
): AssetResultMatch[] =>
  matches.filter(hasMoreThanTypename) as AssetResultMatch[];

const hasMoreThanTypename = (
  match: unknown
): match is Record<string, unknown> =>
  Boolean(match) &&
  typeof match === 'object' &&
  match !== null &&
  Object.keys(match).length > 1;
